import styled from "styled-components";

export default styled.h4`
  padding: 0;
  margin: 0;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: #474747;
  width: 100%;
`;
